const FoodRankTypes = {
    FETCH_START:    '[FOOD][RANK] FETCH START',
    FETCH_SUCCESS:  '[FOOD][RANK] FETCH SUCCESS'
};

export default FoodRankTypes;